import { useMemo } from 'react';
import { useUserStore } from '@core/user/useUserStore';
import { buildPortalAccessContext } from '@/access/buildPortalAccessContext';
import type { PortalAccessContext } from '@/access/portalAccess.types';

const usePortalAccess = (): PortalAccessContext => {
  const role = useUserStore((state) => state.currentUser?.role);

  return useMemo(() => buildPortalAccessContext(role), [role]);
};

export default usePortalAccess;
